"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var PopoutCompany = /** @class */ (function (_super) {
            __extends(PopoutCompany, _super);
            function PopoutCompany() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            PopoutCompany.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // A popout window should display the company of the active form in its window
                $dyn.observe($dyn.activeForm, function () {
                    var activeForm = $dyn.context($dyn.value($dyn.activeForm));
                    if (activeForm) {
                        _this.CompanyName(activeForm.FormCompanyName());
                        _this.Company(activeForm.FormCompany());
                    }
                });
            };
            return PopoutCompany;
        }($dyn.ui.Control));
        controls.PopoutCompany = PopoutCompany;
        $dyn.ui.addObservablePropertiesToPrototype(PopoutCompany.prototype, {
            Company: "",
            CompanyName: "",
        });
        $dyn.adapter({ id: "PopoutCompanyButton", controlType: "PopoutCompany", template: "PopoutCompanyButton" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PopoutCompany.js.map
